import { Search, PlusCircle, Download, TrendingUp, TrendingDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

export function ComptabilitePage() {
  const transactions = [
    {
      id: 1,
      date: "2025-06-05",
      description: "Inscription - Famille Martin",
      montant: 450,
      type: "recette",
      statut: "payé",
    },
    {
      id: 2,
      date: "2025-06-04",
      description: "Achat matériel - Planches de surf",
      montant: -1200,
      type: "dépense",
      statut: "payé",
    },
    {
      id: 3,
      date: "2025-06-03",
      description: "Inscription - Famille Durand",
      montant: 275,
      type: "recette",
      statut: "en_attente",
    },
  ];

  const stats = [
    {
      titre: "Recettes du mois",
      montant: "€12,450",
      evolution: "+8%",
      type: "positive",
    },
    {
      titre: "Dépenses du mois",
      montant: "€3,200",
      evolution: "+12%",
      type: "negative",
    },
    {
      titre: "Bénéfice net",
      montant: "€9,250",
      evolution: "+5%",
      type: "positive",
    },
    {
      titre: "En attente",
      montant: "€1,875",
      evolution: "-15%",
      type: "warning",
    },
  ];

  return (
    <>
      <header className="flex items-center justify-between border-b border-gray-200 bg-white px-6 py-4">
        <h1 className="text-2xl font-bold text-gray-800">Comptabilité</h1>
        <div className="flex items-center space-x-4">
          <div className="relative w-80">
            <Search className="absolute top-1/2 left-3 -translate-y-1/2 transform text-gray-400" size={18} />
            <Input placeholder="Rechercher une transaction..." className="w-full rounded-lg border border-gray-300 py-2 pr-4 pl-10" />
          </div>
          <Button variant="outline" size="icon" className="h-10 w-10">
            <Download size={18} />
          </Button>
          <Button className="bg-blue-500 text-white hover:bg-blue-600">
            <PlusCircle size={18} className="mr-2" />
            Nouvelle Transaction
          </Button>
        </div>
      </header>

      <main className="flex-1 overflow-y-auto p-6">
        <div className="mb-8 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {stats.map((stat, index) => (
            <Card key={index}>
              <CardHeader className="pb-3">
                <CardTitle className="text-sm font-medium text-gray-600">{stat.titre}</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">{stat.montant}</div>
                <div className="flex items-center text-xs">
                  {stat.type === "positive" ? (
                    <TrendingUp size={12} className="mr-1 text-green-600" />
                  ) : (
                    <TrendingDown size={12} className="mr-1 text-red-600" />
                  )}
                  <span className={`${stat.type === "positive" ? "text-green-600" : stat.type === "negative" ? "text-red-600" : "text-orange-600"}`}>
                    {stat.evolution} ce mois
                  </span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <Card>
          <CardHeader>
            <div className="flex items-center justify-between">
              <CardTitle>Transactions Récentes</CardTitle>
              <Tabs defaultValue="all">
                <TabsList>
                  <TabsTrigger value="all" className="text-sm">
                    Toutes
                  </TabsTrigger>
                  <TabsTrigger value="recettes" className="text-sm">
                    Recettes
                  </TabsTrigger>
                  <TabsTrigger value="depenses" className="text-sm">
                    Dépenses
                  </TabsTrigger>
                </TabsList>
              </Tabs>
            </div>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {transactions.map((transaction) => (
                <div key={transaction.id} className="flex items-center justify-between border-b border-gray-100 pb-4">
                  <div>
                    <p className="font-medium">{transaction.description}</p>
                    <p className="text-sm text-gray-600">{transaction.date}</p>
                  </div>
                  <div className="flex items-center space-x-4">
                    <Badge variant={transaction.statut === "payé" ? "default" : "secondary"}>{transaction.statut === "payé" ? "Payé" : "En attente"}</Badge>
                    <div className={`text-lg font-semibold ${transaction.montant > 0 ? "text-green-600" : "text-red-600"}`}>
                      {transaction.montant > 0 ? "+" : ""}
                      {transaction.montant}€
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </main>
    </>
  );
}
